// the library has bug when taking parameter to transform in array item
var objectMapper = require("object-mapper");

export const countryStateMapper = (data: any) => objectMapper(data, map);

const map = {
  "[].id": "[].id",
  "[].name": "[].label",
  "[].abbreviation": "[].code",
};
